export default __webpack_public_path__ + "static/media/November2018.3894c42b.png";